<script lang="ts">
    import { createEventDispatcher } from "svelte";

    const dispacth = createEventDispatcher();

    export let title: string = '';

    function onBackBtnClick() {
        dispacth('back');
    }

</script>

<style lang="scss">

    .top-bar {
        display: flex;
        align-items: center;
        width: 100%;
        height: 3rem;
        background-color: var(--route-color, var(--color-primary));
        color: #fff;
    }

    .top-bar-btn {
        width: 3rem;
        height: 3rem;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;

        img {
            width: 1rem;
            height: 1rem;
        }
    }

    .title {
        width: calc(100% - 6rem);
        text-align: center;
    }

</style>

<div class="top-bar">
    <button type="button" class="top-bar-btn top-bar-left-btn" on:click={onBackBtnClick}>
        <img src="/images/angle-white.svg" alt="">
    </button>
    <div class="title one-line">{title}</div>

    <slot name="btn"></slot>

    <!-- {#if $user}
    <button type="button" class="top-bar-btn top-bar-right-btn" on:click={onSignOutClick}>
        <img src={$user.image} alt="">
    </button>
    {/if} -->
</div>
